module.exports = __webpack_public_path__ + "./images/backboard.ea468e7e.jpg";